import script from "./AHeaderWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./AHeaderWallet.vue?vue&type=script&setup=true&lang=js"

import "./AHeaderWallet.vue?vue&type=style&index=0&id=1e1cf4ef&lang=scss"

const __exports__ = script;

export default __exports__